import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import useGetCarrier from './queries/useGetCarrier';
import useUpdateCarrier from './queries/useUpdateCarrier';

import FormBase from '@/components/forms/new/FormBase';
import { LoadingIndicator } from 'components/v4';
import {
    breadCrumbTrailEdit as breadCrumbTrail,
    editHeader as header,
    carriersPath,
} from './constants';
import CarrierNameField from './formFields/CarrierNameField';

const CarriersEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { darkMode } = useSelector((state) => state.settings);

    const {
        data: carrierData,
        isLoading: carrierLoading,
        isFetching: carrierFetching,
        isError: notFound,
    } = useGetCarrier(id);

    const handleUpdateSuccess = () => {
        toast.success('Carrier updated successfully!');
        navigate(carriersPath);
    };

    const handleUpdateError = (error) => {
        console.error('Failed to update carrier:', error);
        toast.error('Failed to update carrier. Please try again.');
    };

    const { mutate: updateCarrier, isPending: updatePending } =
        useUpdateCarrier(handleUpdateSuccess, handleUpdateError);

    const finalFormSubmit = async (values) => {
        if (!values.name || values.name.length < 2) {
            console.error(
                'Carrier name is required and must be at least 2 characters',
            );
            return;
        }

        updateCarrier({ id, name: values.name });
    };

    const formFields = (errors, touched) => [
        <CarrierNameField
            key="name"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
    ];

    if (carrierLoading || carrierFetching) {
        return <LoadingIndicator />;
    }

    if (notFound) {
        return (
            <FormBase
                breadCrumbTrail={breadCrumbTrail}
                header={header}
                initialValues={{ name: '' }}
                finalFormSubmit={async () => {}}
                hideSubmitButton
                backLink={[carriersPath, { state: { index: 0 } }]}>
                {() => [
                    <p key="not-found">
                        This carrier no longer exists. It may have already been
                        deleted.
                    </p>,
                ]}
            </FormBase>
        );
    }

    const editInitialValues = {
        name: carrierData?.name || '',
    };

    return (
        <FormBase
            isSubmitDisabled={updatePending}
            isLoading={updatePending}
            breadCrumbTrail={breadCrumbTrail}
            header={header}
            initialValues={editInitialValues}
            finalFormSubmit={finalFormSubmit}
            backLink={[carriersPath, { state: { index: 0 } }]}>
            {({ errors, touched }) => formFields(errors, touched)}
        </FormBase>
    );
};

export default CarriersEdit;
